module.exports = __webpack_public_path__ + "img/the-first-noel-image.45fc3438.png";